// @ts-expect-error untyped file
import { createAction } from 'flux-actions';
import { UPDATE_VISITOR_IDENTIFICATION_ENABLED } from '../constants/ActionTypes';
export const updateVisitorIdentificationEnabled = createAction(UPDATE_VISITOR_IDENTIFICATION_ENABLED, data => {
  return {
    enabled: !!data.identificationToken
  };
});